import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

const LoansLegalDisclaimer = () => (
    <Stack space="space15">
        <Text variant="80" weight="bold">
            Missing payments will have severe consequences and may make
            obtaining credit more difficult in the future.
        </Text>
        <Text variant="80">
            If you decide to take out a homeowner loan, you agree that your
            personal details will be sent to a credit broker who will contact
            you by telephone and/or email to find out more about your
            requirements. This allows the broker to ensure you are introduced to
            loan products which meet your individual requirements and financial
            circumstances.
        </Text>
        <Text variant="80">
            Should you choose to make an application, the broker will advise you
            of any arrangement fee you may be charged when you take out a loan.
        </Text>
    </Stack>
)

export default LoansLegalDisclaimer
